import functions from './functions.js';
import Slider from './Slider.js';
import Tab from 'bootstrap/js/dist/tab';
import Modal from 'bootstrap/js/dist/modal';
import {SimpleGuests, SimpleGuestsDefaults} from "./simple-guests.js";
import {FormGuide, FormGuideDefaults} from "./form-guide.js";
import lozad from 'lozad';

SimpleGuestsDefaults.infantsAge = 6;

$(function() {

    const language = functions.getLang();

    if (functions.isMobile()) 
    {
        $('.show-on-desktop.list-search').remove();
        $('.show-on-mobile').removeClass('d-none');
    }
    else 
    {
        $('.show-on-mobile').remove();
        $('.show-on-desktop.list-search').removeClass('d-none');
    }

    // DATA WIDGET AVENTIR 
    const widgets = document.querySelectorAll('div[data-av-widget-id]');
    const wisgetsSet = [];
    function fixWidget() {
        widgets.forEach(el => {
            const sr = el.shadowRoot;
            if (!sr) return;

            const ul = sr.querySelector('ul');
            if (!ul) return;
            if ( ul.style.backgroundColor.indexOf('transparent') == -1 ) {
                ul.style.setProperty('background-color', 'transparent', 'important');
                wisgetsSet.push(1);
            }
        });
        if ( widgets.length == wisgetsSet.length ) {
            clearInterval(widgetInterval);
        }
    }
  
   fixWidget();
   const widgetInterval = setInterval(fixWidget, 100);

    

    
    $('body').on('click', '.dropdown-menu', e => {
        e.stopPropagation();
    });

    

    


    const guestsTranslations = {
        en: {
            guests: 'guests',
            infants: 'infants'
        },
        de: {
            guests: 'gäste',
            infants: 'kleinkinder'
        },
        it: {
            guests: 'ospiti',
            infants: 'neonati'
        },
        hr: {
            guests: 'gosta',
            infants: 'dojenčad'
        }
    };

    $('.simple-guests').each((i, elem) => {
		elem._simpleGuests = new SimpleGuests(elem, {
            btnValueTpl: (adults, children, infants, extras) => {
                return `${adults + children + infants} ${guestsTranslations[language].guests}${extras ? ', ' + extras + ' ' + guestsTranslations[language].infants : ''}`;
            }
        });
	});

    $('.form-guide').each((i, elem) => {
		new FormGuide(elem);
	});

    let homeSlider = [];
    $('[id^=home-slider]').each((i, elem) => {
        const $slides = $(elem).find('.keen-slider__slide');
        homeSlider[i] = new Slider('#' + $(elem).attr('id'), {
            loop: true,
            fade: true,
            arrows: true,
            slides: {
                perView: 1,
            },
            autoplay: 6000,
            defaultAnimation: {
                duration: 0
            },
            detailsChanged: (s) => {
              s.slides.forEach((element, idx) => {
                if ( s.track.details.slides[idx].portion == 0 ) {
                    element.style.opacity = 0;
                }
                if ( s.track.details.slides[idx].portion == 1 ) {
                    element.style.opacity = 1;
                    element.classList.add('animation');
                }
              })
            },
            renderMode: "custom",
        });

        $slides.each((i, slide) => {
            slide.addEventListener('animationend', () => {
                slide.classList.remove('animation');
            });
        });
    });
    
    let unitCards = [];
    $('[id^=unit-cards]').each((i, elem) => {
        unitCards[i] = new Slider('#' + $(elem).attr('id'), {
            rubberband: false,
            loop: true,
            arrows: true,
            pager: false,
            slides: {
                perView: 1,
                spacing: 0,
            },
            autoplay: 0,
            drag: true,
            pauseOnHover: false,
            autoLoadSlides: 1
        });
    });

    
   // special offer slider
   $('[id=offer-slider]').each((i, elem) => {
    let $items =  $(elem).find('.keen-slider__slide');
    new Slider(elem, {
        loop: true,
        arrows: true,
        pager: false,
        slides : {
            perView: 3,
            spacing: 5,
        },
      breakpoints: {
            '(max-width: 1400px)': {
                slides : {
                    perView: 2,
                    spacing: 5,
                },
            },
        
        
            '(max-width: 767px)': {
                slides : {
                    perView: 1.09,
                    spacing: 0,
                },
            },
        },
    });
});


   // home reviews slider MOBILE
   $('[id=home-reviews-mobile-slider]').each((i, elem) => {
    let $items =  $(elem).find('.keen-slider__slide');
        new Slider(elem, {
            loop: true,
            arrows: false,
            pager: true,
            slides : {
                perView: 1,
            },
        });
    });


   // home reviews slider
$('[id=home-reviews-slider]').each((i, elem) => {
    let $items =  $(elem).find('.keen-slider__slide');
    new Slider(elem, {
        loop: true,
        arrows: true,
        pager: false,
        fade: true,
        slides : {
            perView: 1,
        },
        breakpoints: {
            '(max-width: 992px)': {
                fade: false,
                renderMode: 'precision'
            },
        },
        // autoplay: 6000,
        // defaultAnimation: {
        //     duration: 0
        // },
        detailsChanged: (s) => {
            if ( !s.options.fade ) { return; }
            s.slides.forEach((element, idx) => {
              if ( s.track.details.slides[idx].portion == 0 ) {
                  element.style.opacity = 0;
              }
              if ( s.track.details.slides[idx].portion == 1 ) {
                  element.style.opacity = 1;
                  element.classList.add('animation');
              }
            })
          },
          renderMode: "custom",
    });

    // $items.each((i, slide) => {
    //     slide.addEventListener('animationend', () => {
    //         slide.classList.remove('animation');
    //     });
    // });
        
});


let catalogueSliderCrads = [];
    $('[id^=catalogue-slider-cards]').each((i, elem) => {
        catalogueSliderCrads[i] = new Slider('#' + $(elem).attr('id'), {
            rubberband: false,
            loop: true,
            arrows: true,
            pager: true,
            slides: {
                perView: 1,
                spacing: 0,
            },
            autoplay: 0,
            drag: true,
            pauseOnHover: false,
            autoLoadSlides: 1
        });
    });
/*
    let catalogueSliderCrads = [];
    $('[id^=catalogue-slider-cards]').each((i, elem) => {
        catalogueSliderCrads[i] = new Slider('#' + $(elem).attr('id'), {
            rubberband: false,
            loop: true,
            arrows: true,
            pager: true,
            slides: {
                perView: 1,
                spacing: 0,
            },
            autoplay: 0,
            drag: true,
            pauseOnHover: false,
            breakpoints: {
                '(max-width: 1050px)': {
                    origin: 'center',
                    slides: {
                        perView: 2.15,
                        spacing: 0,
                    },
                    loop: false,
                    drag: true,
                    arrows: false,
                    autoplay: 0
                },
                '(max-width: 768px)': {

                    origin: 'center',
                    slides: {
                        perView: 1.08,
                        spacing: 0,
                    },
                    loop: false,
                    drag: true,
                    autoplay: 0
                },
            },
            selector: '.first-slide',
        });
    });
*/
    if(! $('.page-type-details')[0]) {

        const logoWhite = $('.navbar-logo-white');
        const logoBlack = $('.navbar-logo-black');


        $(window).scroll(e => {
            if($(window).scrollTop() > 0 && window.innerWidth > 992 ){
                    $('#navbarTogglerMain').addClass('visible')
                    logoWhite.addClass('d-none');
                    logoBlack.removeClass('d-none');
            
            } else {
                     $('#navbarTogglerMain').removeClass('visible');
                     logoBlack.addClass('d-none');
                     logoWhite.removeClass('d-none');
                } 

        });

        if (window.innerWidth < 992) {
            $('.main-navbar').removeClass('navbar-dark');
            $('.main-navbar').addClass('navbar-light');

        } else {
            $('.main-navbar').addClass('navbar-dark');
            $('.main-navbar').removeClass('navbar-light');
        }
      
    }


    /*
    const observerVillas = lozad('.villas-lozad', {
        rootMargin: '200px 200px',
        loaded: el => {
            let villasSlider = [];
            $(el).find('[id^=villa-card-slider]').each((i, elem) => {
                const length = $(elem).children('.keen-slider__slide').length;
                villasSlider[i] = new Slider('#' + $(elem).attr('id'), {
                    rubberband: false,
                    loop: true,
                    arrows: true,
                    drag: true,
                    controls: true,
                    slides: {
                        perView: 1
                    },
                    spacing: 0,
                    duration: 1000,
                    autoplay: 0,
                    pauseOnHover: true,
                    pager: false,   
                    autoLoadSlides: 2,
                        
                });
            });
                $(el).triggerHandler('lozadLoaded');
            }
        });
        observerVillas.observe();
        
        
        */


    let blogSlider = [];
    $('[id^=blog-slider]').each((i, elem) => {
        const length = $(elem).children('.keen-slider__slide').length;
        blogSlider[i] = new Slider('#' + $(elem).attr('id'), {
            rubberband: false,
            loop: true,
            arrows: true,
            pager: true,
            slides: {
                perView: 3,
                spacing: 0,
            },
            autoplay: 0,
            drag: true,
            pauseOnHover: false,
            breakpoints: {
                '(max-width: 1050px)': {
                    origin: 'center',
                    slides: {
                        perView: 2.15,
                        spacing: 0,
                    },
                    loop: false,
                    drag: true,
                    arrows: false,
                    autoplay: 0
                },
                '(max-width: 768px)': {

                    origin: 'center',
                    slides: {
                        perView: 1.08,
                        spacing: 0,
                    },
                    loop: false,
                    drag: true,
                    autoplay: 0
                },
            },
            //selector: '.first-slide',  
        });
    });

    let categoriesSlider = [];
    $('[id^=categories-slider]').each((i, elem) => {
        const length = $(elem).children('.keen-slider__slide').length;
        categoriesSlider[i] = new Slider('#' + $(elem).attr('id'), {
            rubberband: true,
            loop: true,
            arrows: true,
            drag: true,
            slides: {
                perView: 4,
                spacing: 0,
            },
            autoplay: 0,
            breakpoints: {
                '(max-width: 1050px)': {
                    origin: 'center',
                    slides: {
                        perView: 2.15,
                        spacing: 0,
                    },
                    loop: false,
                    drag: true,
                    arrows: false,
                    autoplay: 0
                },
                '(max-width: 768px)': {
                    origin: 'center',
                    slides: {
                        perView: 1.07,
                        spacing: 0,
                    },
                    loop: false,
                    drag: true,
                    arrows: false
                },
            },      
        });
    });



    /* gallery */
    const lg = {};
    window.showGallery = (index, id) => {
        index = +index || 0;
        if ( lg[id] ) {
            lg[id].index = index;
            lg[id].build(index);
        } else {
            let $elem = $('[data-images-' + id + ']');
            lg[id] = $elem.lightGallery({
                dynamic: true,
                thumbnail: false,
                toogleThumb: false,
                thumbWidth: 130,
                thumbMargin: 10,
                download: false,
                preload: 2,
                index: index,
                dynamicEl: JSON.parse($elem.attr('data-images-' + id))
            }).data('lightGallery');
        }
    };
    $('[data-gallery-id]').on('click', function (e) {
        e.preventDefault();
        let galleryId = $(this).attr('data-gallery-id');
        galleryId && showGallery($(this).attr('data-index'), galleryId);
    });
    
    /** Modal */
    $('.gallery-modal-launcher').on('click', function (e) {
        e.preventDefault();
       $('.gallery-modal').removeClass('d-none');
       $('body').addClass('overflow-hidden');
    });

    $(document).on('click', '.gallery-modal', function(e) {
        if (e.target === this) {
            closeGalleryModal();
        }
    });

    $(document).on('click', '.close-gallery-modal', function() {
        closeGalleryModal();
    });

    $(document).keyup(function(e) {
        if (e.key === "Escape") {
            closeGalleryModal();
        }
    });

    $('.gallery-modal .container.content').on('scroll', throttle(function() {
        var scrollTop = $(this).scrollTop();
        var $header = $('.gallery-modal .modal-header');
        
        if (scrollTop > 0) {
            $header.addClass('scrolled');
        } else {
            $header.removeClass('scrolled');
        }
    }, 300));

    function closeGalleryModal() {
        $('.gallery-modal').addClass('d-none');
        $('body').removeClass('overflow-hidden');
    }

    function throttle(func, wait) {
        let timeout;
        return function(...args) {
            if (!timeout) {
                timeout = setTimeout(() => {
                    func.apply(this, args);
                    timeout = null;
                }, wait);
            }
        };
    }

    /**  End modal  */

    // don't focus div with gallery
    $('[data-gallery-id]').on('focus', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        e.stopPropagation();
        return false;
    });
    
    const $wpGallery = $('.wp-block-gallery');
    const $wpGalleryLinks = $wpGallery.find('a');
    const wpGalleryArray = $wpGalleryLinks.map((i, elem) => {
        const $elem = $(elem);
        const $img = $elem.find('img');
        // let imgs = $img.attr('src').split(', ');
        let imgs = $img.attr('srcset').split(', ');
        let sizes = $.map(imgs, img => {
            let size = img.match(/(\d+)w$/);
            return size ? +size[1] : 9999;
        });
        let minSize = sizes.indexOf(Math.min.apply(Math, sizes));
        minSize = minSize > -1 ? minSize : 0;
        let img = imgs[minSize].replace(/ \d+w$/, '');
        return {
            src: $elem.attr('href'),
            thumb: img
        };
    });
    $wpGallery.on('click', 'a', e => {
        e.preventDefault();
        let index = $wpGalleryLinks.index(e.currentTarget);
        if ( $(e).hasClass('lg-on') ) {
            $(e).data('lightGallery').index = index;
            $(e).data('lightGallery').build(index);
        } else {
            $(e).lightGallery({
                dynamic: true,
                thumbnail: true,
                toogleThumb: false,
                thumbWidth: 130,
                thumbMargin: 10,
                download: false,
                autoplay: false,
                preload: 2,
                index: index,
                dynamicEl: wpGalleryArray
            }).addClass('lg-on');
        }
    });

    const viewAllTranslation = {
        en: 'Images',
        de: 'Bilder',
        it: 'Immagini',
        hr: 'Slika'
    };

    $wpGallery.each( (i, elem) => {
        const $links = $(elem).find('a');
        let eq = $links.length >= 4 ? 3 : $links.length-1;
        $links.eq(eq).append(
            `<div class="see-all-images">
            <div class="btn btn-light btn-sm pointer border border-warning rounded-0" data-gallery-id="gallery-section" data-index="0">
                <i class="las la-camera-retro text-warning la-lg"></i>
                <span class="text-dark">${wpGalleryArray.length} ${viewAllTranslation[functions.getLang()]}</span>
            </div>
        </div>`
        );
    } );

    // $wpGallery.each((i, elem) => {
    //     const $wpGalleryLinks = $(elem).find('a');
    //     const wpGalleryArray = $wpGalleryLinks.map((i, elem) => {
    //         const $elem = $(elem);
    //         const $img = $elem.find('img');
    //         let imgs = $img.attr('src').split(', ');
    //         // let imgs = $img.attr('srcset').split(', ');
    //         let sizes = $.map(imgs, img => {
    //             let size = img.match(/(\d+)w$/);
    //             return size ? +size[1] : 9999;
    //         });
    //         let minSize = sizes.indexOf(Math.min.apply(Math, sizes));
    //         minSize = minSize > -1 ? minSize : 0;
    //         let img = imgs[minSize].replace(/ \d+w$/, '');
    //         return {
    //             src: $elem.attr('href'),
    //             thumb: img
    //         };
    //     });
    //     $(elem).on('click', 'a', e => {
    //         e.preventDefault();
    //         let index = $wpGalleryLinks.index(e.currentTarget);
    //         if ( $(elem).hasClass('lg-on') ) {
    //             $(elem).data('lightGallery').index = index;
    //             $(elem).data('lightGallery').build(index);
    //         } else {
    //             $(elem).lightGallery({
    //                 dynamic: true,
    //                 thumbnail: true,
    //                 toogleThumb: false,
    //                 thumbWidth: 130,
    //                 thumbMargin: 10,
    //                 download: false,
    //                 autoplay: false,
    //                 preload: 2,
    //                 index: index,
    //                 dynamicEl: wpGalleryArray
    //             }).addClass('lg-on');
    //         }
    //     });
    //     const viewAllTranslation = {
    //         en: 'Images',
    //         de: 'Bilder',
    //         it: 'Immagini',
    //         hr: 'Slika'
    //     };
    //     $wpGalleryLinks.eq(3).append(
    //         `<div class="see-all-images">
    //         <div class="btn btn-light btn-sm pointer border border-warning rounded-0" data-gallery-id="gallery-section" data-index="0">
    //             <i class="las la-camera-retro text-warning la-lg"></i>
    //             <span class="text-dark">${wpGalleryArray.length} ${viewAllTranslation[functions.getLang()]}</span>
    //         </div>
    //     </div>`
    //     );
    // });
    
    /* end gallery */
    
    // menu links active
    const path = location.pathname.replace(/\/$/, '');
    $('.main-header [href], footer [href]').each((i, link) => {
        let href = link.getAttribute('href');
        if ( href && href != '#' ) {
            href = href.split('?')[0].replace(/\/$/, '');
            if ( path === href ) {
                $(link).addClass('active').closest('.nav-item').addClass('active');
            }
        }
    });

    // global tooltip init
    //('[data-toggle="tooltip"]').tooltip();

    // mobile menu handling
    (() => {
        const $header = $('.main-header');
        const $collapser = $('#main-menu');

        // ensure navbar toggler also open closes main-menu
        $collapser
            .on('show.bs.collapse', () => {
                document.body.classList.add('modal-transition');
                document.body.classList.add('modal-active');
            })
            .on('hide.bs.collapse', () => {
                document.body.classList.remove('modal-active');
            })
            .on('hidden.bs.collapse', () => {
                document.body.classList.remove('modal-transition');
            });

        // click on "overlay" closes menu
        $header.find('.header-overlay').on('click', () => {
            $collapser.collapse('hide');
        });
    })();

    // scrool to element handling
    $(document).on('click', '[data-scroll-to]', e => {
        e.preventDefault();
        const $this = $(e.target);
        let scrollTo = $this.attr('data-scroll-to').split(',');
        functions.scrollToElement(scrollTo[0], scrollTo[1] || 0);
    });
    
    // global datepicker init with automatic "dateTo" set if provided
    let displayDate = new Date('2019-06-01');
    let now = functions.cleanDate(new Date);
    if ( now > displayDate ) {
        displayDate = now;
    }

    $('.datepicker').each((i, elem) => {
        const $datepicker = $(elem);
        const minDate = $datepicker.attr('data-min');
        const maxDate = $datepicker.attr('data-max');
        $datepicker.flatpickr({
            altInput: true,
            wrap: true,
            altFormat: "j.m.Y",
            dateFormat: "Y-m-d",
            minDate: minDate ? minDate : now,
            maxDate: maxDate ? maxDate : null,
            disableMobile: true,
            prevArrow: '<i class="la la-angle-left pr-2"></i>',
            nextArrow: '<i class="la la-angle-right pl-2"></i>',
            onChange(selectedDates, dateStr, instance) {

                const $first = $(instance.input);
                // prevent other logic if second datepicker is triggered by first
                if (instance._openByFirst) {
                    delete instance._openByFirst;
                    return;
                }
                
                if ($first.attr('data-firstDate')) {
                    const $second = $first.closest('form').find('[data-secondDate]').closest('.datepicker');
                    if ($second.length) {

                        var firstDate = new Date(selectedDates[0]);
                        firstDate.setDate(firstDate.getDate() + 1);
                        
                        var secondInstance = $second[0]._flatpickr;
                        // check if firstDate is invalid
                        if (firstDate.getTime() === firstDate.getTime()) {
                            secondInstance._openByFirst = true;
                            secondInstance.set('minDate', firstDate);
                            if (!secondInstance.selectedDates[0]) {
                                firstDate.setDate(firstDate.getDate() + 6);
                                secondInstance.setDate(firstDate);
                            }
                            secondInstance.open();
                            $(secondInstance.altInput).focus();
                        }
                        else if (secondInstance.selectedDates[0]) {
                            secondInstance.clear();
                        }
                    }
                }
                // check if second date is cleared
                else if ($first.attr('data-secondDate') && !selectedDates[0]) {
                    $first.closest('form').find('[data-firstDate]').closest('.datepicker')[0]._flatpickr.clear();
                }
            },
            onOpen(selectedDates, dateStr, instance) {
                if (instance.input.getAttribute('data-secondDate')) {
                    const $first = $(instance.input).closest('form').find('[data-firstDate]').closest('.datepicker');
                    if ($first.length) {
                        const firstInstance = $first[0]._flatpickr;
                        if (!firstInstance.input.value) {
                            instance.close();
                            firstInstance.open();
                            firstInstance.altInput.focus();
                            return;
                        }
                    }
                }
                !dateStr && instance.jumpToDate(minDate ? minDate : displayDate);
            }
        });
        // to style clear toggler
        $datepicker.on('change', e => requestAnimationFrame(() => $(e.target).parent().toggleClass('datepicker-value', !!e.target.value)));
    }); 

    $('.datepicker-range').each((i, elem) => {
        const $datepicker = $(elem);
        const minDate = $datepicker.attr('data-min');
        const maxDate = $datepicker.attr('data-max');
        const arrival = $datepicker.attr('data-arrival') ? $datepicker.attr('data-arrival') : [];
        const defaultDate = $datepicker.attr('data-defaultDate') ? $datepicker.attr('data-defaultDate') : [];
        const duration = Number($datepicker.attr('data-duration'));
        const position = $datepicker.attr('data-position') || 'auto';
        const minStayText = $datepicker.attr('data-minstay');
        $datepicker.flatpickr({
            mode: "range",
            showMonths: functions.isMobile() ? 1: 2,
            altInput: true,
            wrap: true,
            altFormat: "j.m.Y",
            dateFormat: "Y-m-d",
            defaultDate: defaultDate,
            minDate: minDate && minDate >= now ? minDate : now,
            maxDate: maxDate ? maxDate : null,
            disableMobile: true,
            prevArrow: '<i class="la la-arrow-left la-fw la-2x pr-2"></i>',
            nextArrow: '<i class="la la-arrow-right la-fw la-2x pl-2"></i>',
            locale: {
                rangeSeparator: ' - '
            },
            position: position,
            minStayText: minStayText ? minStayText : '',
            onDayCreate(dObj, dStr, fp, dayElem){
                
                let minStay = 1;
                let to = new Date(maxDate);
                let weekday =  new Date(dayElem.dateObj).getDay();
                weekday = '' + (weekday ? weekday : 7);
                to.setHours(0, 0, 0, 0);
                let onlyCheckInSelected = fp.selectedDates[0] && ! fp.selectedDates[1];
                // let diff = globals.dateDiff(dayElem.dateObj, fp.selectedDates[0]);
                let from = dayElem.dateObj;
                let too = fp.selectedDates[0];
                // let f = Date.UTC(from.getFullYear(), from.getMonth()+1, from.getDate());
                // let t = Date.UTC(too.getFullYear(), too.getMonth()+1, too.getDate());
            
                let diff = Math.round((from - too) / (1000 * 60 * 60 * 24));

                if (onlyCheckInSelected) {
                    if (Math.abs(diff) < minStay) {
                        dayElem.className += ' flatpickr-disabled ';
                        if (diff) {
                            if (minStayText)
                            {
                                $(dayElem).tooltip({
                                    title: minStayText.replace('{$min_stay}', minStay) || ''
                                });
                            }
                        }
                    }
                }

                if ( dayElem.dateObj > to || (arrival.length && $.inArray( weekday , arrival ) == -1) ) {
                    dayElem.classList.add('unselectable');
                }
            },
        });
        // to style clear toggler
        $datepicker.on('change', e => requestAnimationFrame(() => $(e.target).parent().toggleClass('datepicker-value', !!e.target.value)));
    });

    // let userDates = functions.getCookie('user_dates');
    // if(userDates) {
    //     let userDateFrom = new Date(userDates.split(' - ')[0]);
    //     let today = new Date( new Date().getFullYear(), new Date().getMonth(), new Date().getDate() );
    
    //     if(userDateFrom < today) {
    //         functions.setCookie('user_dates', '');
    //         userDates = functions.getCookie('user_dates');
    //     }
    // }

    // if(userDates && $('.datepicker-range')[0]) {
    //     userDates = userDates.split(' - ');
    //     if(userDates.length == 2) $('.dates-clear').removeClass('d-none');
    //     let dateFrom = userDates[0] ? userDates[0] : null;
    //     let dateTo = userDates[1] ? userDates[1] : null;
    
    //     if(dateFrom && dateTo) {
    //         $('.datepicker-range')[0]._flatpickr.setDate([dateFrom, dateTo]);
    //     } else if(dateFrom) {
    //         $('.datepicker-range')[0]._flatpickr.setDate([dateFrom, dateFrom]);
    //     }
    // }

    // $('[name="dates"]').on('change', e => {
    //     functions.setCookie('user_dates', $(e.target).val());
    // });

    // select2 templates can be defined as data-template="destinations" ...
    const selectTemplates = {
        destinations: data => {

            if ( !data.element ) {
                return data.text;
            }
            if(data.placeId && data.placeName) {
                //const $element = $(data.element).addClass(data.element.className).text(data.placeName);
                const $element = $('<span>').addClass(data.element.className).text(data.placeName);
                return $element;
            }
            if(data.text) {
                const $element = $('<span>').addClass(data.element.className).text(data.text);
                let elemClass;
                console.log((data.id) );
                switch ( (data.id).split(':').length ) {
                    case 1: elemClass = ''; break;
                    case 2: elemClass = 'ps-1'; break;
                    case 3: elemClass = 'ps-4 '; break;
                    case 4: elemClass = 'ps-4 '; break;
                    default: elemClass = 'ps-4'; break;
                }
                switch ( (data.id).split('|')[1] || 0 ) {
                    case 'c': elemClass = ''; break;
                    case 'r': elemClass = 'ps-1'; break;
                    case 'ri': elemClass = 'ps-4 '; break;
                    case 'p': elemClass = 'ps-4 '; break;
                    default: elemClass = 'ps-4'; break;
                }
                $element.addClass(elemClass);
                return $element;
            }
        },
    };

    // global init select2
    // data-templates
    // data-data
    // data-allow-clear
    // data-nosearch
    // placeholder
    $.map($('.select2'), elem => {
        const $elem = $(elem);
        const config = { dropdownParent: $elem.parent(), language: language };
        config.allowClear = $elem.attr('data-allow-clear');

        // find select2 which has an attribute data-data
        const data = $elem.attr('data-data');
        if ( data ) {
            try {
                config.data = JSON.parse(data);
            } catch (e) {}
        } 
        else if ( $elem.attr('data-special') ) {
            let newData = $('body').attr('data-select-' + $elem.attr('data-special'));
            config.data = JSON.parse(newData);
        }

        if ( $elem.attr('data-template') ) {
            config.templateResult = selectTemplates[$elem.attr('data-template')];
        }
        if ( $elem.attr('data-template-selection') ) {
            config.templateSelection = selectTemplates[$elem.attr('data-template-selection')];
        }

        if ( $elem.attr('data-nosearch') !== undefined ) {
            config.minimumResultsForSearch = Infinity;
        }

        let placeholder = $elem.attr('placeholder');
        $elem.removeAttr('placeholder');
        config.placeholder = placeholder || ' ';
        
        $elem.select2(config)
            .on('select2:clear', () => {
                $elem[0].cleared = true;
            })
            .on('select2:opening', e => {
                if ( $elem[0].cleared ) {
                    e.preventDefault();
                    $elem[0].cleared = false;
                }
            });
    });
    
    // advanced form controls
    // input-popover
    $('body').on('click', '.dropdown-menu-popover', e => {
        e.stopPropagation();
    });

    $('#cookie-bar-accept').on('click', function (e) {
        functions.setCookie('cookie_usage', 'accepted');
        $("#cookie-bar").addClass('d-none');
    });

    // $('.currency').on('click', function (e) {
    //     functions.setCookie('currency', $(this).data('currency'));
    //     location.reload();
    // });

    /*$('.currency-change').on('click', function (e) {
        functions.setCookie('currencyIdTo', e.target.id);
        location.reload();
    });*/



    function showFixedExchangeRate()
    {
        let date = new Date();
        const x = new Date('2022-12-31');
        const y = new Date('2023-07-01');

        let currencyId = functions.getCookie('currencyIdTo') || 1;
        let text = {
                'hr' : 'Fiksni tečaj konverzije: 1 € = 7,53450 kn',
                'en' : 'Fixed conversion rate: 1 € = 7,53450 kn',
                'de' : 'Feste Conversion-Rate: 1 € = 7,53450 kn',
                'it' : 'Tasso di conversione fisso: 1 € = 7,53450 kn',
                'fr' : 'Taux de conversion fixe : 1 € = 7,53450 HRK',
                'pl' : 'Stały kurs wymiany: 1 € = 7.53450 HRK',
                'hu' : 'Rögzített átváltási árfolyam: 1 € = 7,53450 HRK',
                'es' : 'Tasa de conversión fija: 1€ = HRK 7.53450',
                'no' : 'Fast konverteringsfrekvens: €1 = HRK 7,53450',
                'nl' : 'Vaste wisselkoers: €1 = HRK 7.53450',
                'da' : 'Fast konverteringsrate: 1 € = 7,53450 HRK',
                'sv' : 'Fast konverteringsfrekvens: 1 € = 7,53450 HRK',
                'cz' : 'Pevný směnný kurz: 1 EUR = 7,53450 HRK',
                'sl' : 'Fiksni menjalni tečaj: 1 € = 7,53450 HRK',
                'sk' : 'Pevný konverzný kurz: 1 € = 7,53450 HRK'
        };

        if (date <= x)
        {
            if (currencyId == 2) return text[language];
            return null;
        }

        if (date >= y) return null;

        if (currencyId == 1 && language == 'hr') return text[language];

        return null;
    }

    $('.showFixedExchangeRate').html(showFixedExchangeRate());

    /*var id = functions.getCookie('currencyIdTo') ? functions.getCookie('currencyIdTo') : 1;
    if(id)
    {
        let all = JSON.parse($('.currency-selected').attr('data-currencies'));
        $('.currency-selected .currencyCode').text(all[id]);
        
       $('.currency-change').each( (i, elem) => {
           if(elem.id == id) $(elem).addClass('active');
       });
    }  */

    /*if(id && id != 1 && id != 2)
    {
        let exRates = JSON.parse($('.currency-selected').attr('data-exchangeRates'));
        let ex = exRates[id];
        $('.price').each( (id, el) => {
            let price = $(el).attr('data-priceEuro');
            let exPrice = new Intl.NumberFormat('de-DE').format(Math.round(ex['rate'] * price));
            $(el).text(exPrice);
        });
    }*/


    
    // var myCollapsible = document.getElementById('navbarSupportedContent');
    // myCollapsible.addEventListener('show.bs.collapse', function (e) {
    //     if ($(e.target).attr('id') == 'navbarSupportedContent')
    //     {
    //         $('.main-navbar').addClass('opened');
    //         $('body').addClass('overflow-hidden');
    //     }
    // });
    // myCollapsible.addEventListener('hide.bs.collapse', function (e) {
    //     if ($(e.target).attr('id') == 'navbarSupportedContent')
    //     {
    //         $('.main-navbar').removeClass('opened');
    //         $('body').removeClass('overflow-hidden');
    //     }
    // });

    $('.nav-collapse').on('click', function(e) {
        let $target = $(this);
        $target.parent().toggleClass('collapse-active', ! $target.hasClass('collapsed'));
    })

    $('.result-select').on('click', function(e) {
        const $target = $(e.currentTarget);
        const $select = $target.find('.form-control');
        $select.select2('open') && $select.hasClass('select2');
    });

    $('.label-guide').on('mousedown', e => {
        e.stopImmediatePropagation();
        //$(e.currentTarget).find('.form-guide').trigger('focus');
        if ( !$('.select2-container--open').length ) {
            $(e.currentTarget).find('#select-destination').select2('open');
        }
    });

    $('.show-more').each( (i, elem) => {
        let $showMore = $(elem);

        if ($showMore.find('.show-more-content').outerHeight() < 150)
        {
            $showMore.addClass('removeBefore');
            $showMore.next('.show-more-expand').remove();
            return;
        }
        let height = $showMore.attr('data-height');
        let $breakpoint = $showMore.find('.show-more-breakpoint');
        if (height)
        {
            $showMore.css('max-height', +height);
        }
        else if ($breakpoint.length) 
        {
            $showMore.css('max-height', $breakpoint.offset().top - $showMore.offset().top - 25);
        }
        else 
        {
            let $maxHeight = functions.isMobile() ? 
                        ($showMore.outerHeight() * 0.15) : 
                        ($showMore.outerHeight() * 0.3);

            $showMore.css('max-height', $maxHeight);
        }
    
        $showMore.next('.show-more-expand').on('click', e => {
            let $prevSibling = $(e.currentTarget).prev();
            let $maxHeight
            if ($prevSibling.hasClass('removeBefore'))
            {
                let height = $prevSibling.attr('data-height');
                let $breakpoint = $prevSibling.find('.show-more-breakpoint');
                if (height)
                {
                    $maxHeight = +height;
                }
                else if ($breakpoint.length) 
                {
                    $maxHeight = $breakpoint.offset().top - $showMore.offset().top - 25;
                }
                else 
                {
                    $maxHeight = functions.isMobile() ? 
                        ($prevSibling.outerHeight() * 0.15) : 
                        ($prevSibling.outerHeight() * 0.3);
                }
                $prevSibling.css('max-height', $maxHeight);
                $prevSibling.removeClass('removeBefore');
                if ($prevSibling.hasClass('show-more-scroll')) 
                {
                    $('html, body').stop().animate({
                        scrollTop: $prevSibling.offset().top + $maxHeight - $(e.target).outerHeight(),
                    }, 0, 'linear');
                }
            }
            else 
            {
                let $content = $prevSibling.find('.show-more-content');
                $prevSibling.css('max-height', $content.outerHeight());
                $prevSibling.addClass('removeBefore');
            }
        })
    });

    //  read more component
    // $('.read-more').each((i, elem) => {
    //     let $content = $(elem).find('.read-more-content');
    //     let $close = $(elem).find('.read-more-close');
    //     let $open = $(elem).find('.read-more-open');

    //     $($open).on('click', function(e) {
    //         $($content).addClass('no-before expand');
    //         $(e.target).addClass('d-none');
    //         $($close).removeClass('d-none');
    //     })

    //     $($close).on('click', function(e) {
    //         $($content).removeClass('expand');
    //         $(e.target).addClass('d-none');
    //         $($open).removeClass('d-none');

    //         $('html, body').stop().animate({
    //             scrollTop: $(elem).offset().top
    //         }, 0);
    //         setTimeout(function() {
    //             $($content).removeClass('no-before');
    //         }, 500);

    //     })
    // })

    var forms = document.querySelectorAll('.needs-validation');

    // Loop over them and prevent submission
    Array.prototype.slice.call(forms)
        .forEach(function (form) {
        form.addEventListener('submit', function (event) {
            if (!form.checkValidity()) {
                $(form).find('.required').addClass('input-empty');
                event.preventDefault();
                event.stopPropagation();
            }

            form.classList.add('was-validated')
        }, false)
    });

    $('.lang-switcher').find('.dropdown-item').each( function(index, e) {
        if (! $(e).attr('href')) $(e).remove();
    });

    function dateDiff(from, to) {
        let f = Date.UTC(from.getFullYear(), from.getMonth()+1, from.getDate());
        let t = Date.UTC(to.getFullYear(), to.getMonth()+1, to.getDate());
    
        return Math.round((from - to) / (1000 * 60 * 60 * 24));
    }

    $('.search-name').on('submit', function(e){
        e.preventDefault();
        window.location.href = location.protocol
            + '//'
            + location.hostname + '/' + $('.search-name').attr('action') + '#objectName=' + $('footer input[name=objectName]').val();
    });

    let $breadcrumbsPlaceholder = $('.breadcrumbs-placeholder');
    let $breadcrumbs = $('.nl-breadcrumbs');

    if ($breadcrumbsPlaceholder.length && $breadcrumbs.length) {
        $('.nl-breadcrumbs').remove();
        $('.breadcrumbs-placeholder').html($breadcrumbs.clone());
    }

    let $switchTab = $('.switch-tab');
 
    $switchTab.on('click', function(e) {

        let $target = $(e.currentTarget);
        let tabId = $target.attr('data-tab-id');
        let $tabTrigger = $('a.nav-link[data-bs-target="' + tabId + '"]');

        if ($tabTrigger.length) {
            // Use Bootstrap 5 API instead of .trigger('click')
            let tab = new Tab($tabTrigger[0]);
            tab.show();
        }
    });

    let modalShown = functions.getCookie('user_newsletter');
    // let modalShown = false;

    if (! modalShown)
    {
        const news = document.getElementById('newsletterModal')
        // $.getScript("https://www.google.com/recaptcha/api.js?render=6Ld6Pa8UAAAAADgBzavOEcYA1Jxf6iXp8ueY6jp6");
        if(news) {
            const mod = new Modal(news, {
                focus: false,
            });

            news.addEventListener('hidden.bs.modal', function (event) {
                $('html').css({'overflow-y': 'overlay'});
                $('#navbarTogglerMain').attr('style', 'z-index: 1020 !important');
              })

            $(mod).on('shown.bs.modal', e => {
                $('.modal-backdrop').addClass('home-search-backdrop');
                $('.modal-open').addClass('home-search-modal-open');
                
            });
    
            setTimeout(() => {
                mod.show();
                $('html').css({'overflow-y': 'hidden'});
                $('#navbarTogglerMain').attr('style', 'z-index: auto !important');
                functions.setCookie('user_newsletter', true, (86400 * 1000));
            }, 3000);
        }
    }
});


